import * as yup from 'yup';

export const validationSchema = yup.object({
    email: yup.string('Ingrese un E-mail').nullable(true),
    contraeña: yup.string('Ingrese contraseña valida ').nullable(false).matches(/^[0-9]{7,8}$/gm)
});